import React from 'react';
import { UseFormRegister, Controller, Control, Path, FieldValues } from 'react-hook-form';
import {
    Form,
} from 'react-bootstrap';

interface TextBoxCsvProps<T extends FieldValues> {
    name: Path<T>;
    label?: string;
    control: Control<T>;
    register: UseFormRegister<T>
}

/**
 * A reusable component for handling string[] form fields as comma-separated text.
 */
export function TextBoxCsv<T extends FieldValues>({
    name,
    label,
    control,
}: TextBoxCsvProps<T>) {

    return (<Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
        <Controller control={control} name={name}
            defaultValue={null}
            render={({ field: { onChange, onBlur, value = [], ref } }) => (
                <Form.Control
                    ref={ref}
                    value={Array.isArray(value) ? value.join(',') : value}
                    onChange={(e) => {
                        // Update the displayed value immediately, allowing the comma to be visible
                        return onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                        // Only split and update the actual form value when the input loses focus
                        const tmp = e.target.value;
                        const newValue = tmp.split(',').map((str) => str.trim()).filter(Boolean);
                        onChange(newValue);
                    }}
                    type="text"
                />
            )}
        />
    </Form.Group>);
}